key,enValue,enValid,frValue,frValid
lang-code,en,1,fr,1
lang-dir,ltr,1,ltr,1
lang-en,English,1,French,1
lang-fr,anglais,1,français,1
lang-native,English,1,Français,1
ramp.about.open,Open About RAMP,1,Ouvrir À propos de PCAR,1
ramp.about,About RAMP,1,À propos de PCAR,1
ramp.about.esriLegal,Powered by ESRI,1,Propulsé par ESRI,0
ramp.about.esriLink,https://www.esri.com/,1,https://www.esri.com/fr-fr/home,1
ramp.reload,Reload RAMP,1,Recharger PCAR,1
keyboardInstructions.title,Keyboard Instructions,1,Instructions clavier,1
keyboardInstructions.open,Open keyboard instructions,1,Instructions clavier ouvert,1
keyboardInstructions.app,"Use 'Tab' to navigate between sections of the application.",1,"Utilisez la touche Tab pour vous déplacer entre les sections de l'application.",1
keyboardInstructions.lists,"Use the arrow keys to move between items in lists. With a list item selected you can press 'Space' or 'Enter' to click the item. You can also navigate within the list item using 'Tab'.",1,"Lorsqu'un élément de la liste est sélectionné, vous pouvez appuyer sur « Espace » ou « Entrée » pour cliquer sur l'élément. Vous pouvez également vous déplacer au sein de l'élément de la liste au moyen de la touche « Tab ».",1
keyboardInstructions.map,"When the map is selected, use the arrow keys to move around and 'Enter' to select a point.",1,"Lorsque la carte est sélectionnée, utilisez le pavé curseur pour vous déplacer et appuyez sur « Entrée »  pour sélectionner un point.",1
keyboardInstructions.keyboardNav,"Press the key 'S' then 'H' to view available keyboard shortcuts",1,"Appuyez sur la touche « S » puis « H » pour afficher les raccourcis clavier disponibles",0
keyboardInstructions.OK,OK,1,OK,1
map.toggleScaleToMetric,Switch to metric map scale,1,Passer à l'échelle métrique,1
map.toggleScaleToImperial,Switch to imperial map scale,1,Passer à l'échelle impériale,1
map.coordinates.east,E,1,E,1
map.coordinates.west,W,1,O,1
map.coordinates.north,N,1,N,1
map.coordinates.south,S,1,S,1
map.changeLanguage,Change Language,1,Changer de langue,1
map.language.short,EN-CA,1,FR-CA,1
map.language.en,English,1,English,1
map.language.fr,Français,1,Français,1
map.language.curr,current,1,actuel,1
map.export,export map,1,exporter la carte,1
map.layerSwipe.drag,Drag and slide to move,1,Faites glisser et glissez pour déplacer,0
map.layerSwipe.label,Layer swipe,1,Glissement de calque,0
notifications.open,Open Notifications Panel,1,Ouvrir la fenêtre des notifications,1
notifications.title,Notifications,1,Notifications,1
notifications.empty,No new notifications.,1,Aucune nouvelle notification.,1
notifications.controls.dismiss,Dismiss,1,Rejeter,1
notifications.controls.expand,Expand,1,Développer,1
notifications.controls.collapse,Collapse,1,Réduire,1
notifications.controls.clearAll,Clear All,1,Effacer tout,1
panels.access,Press enter or space to access the panel,1,Appuyez sur Entrée ou sur la barre d'espacement pour accéder au panneau,1
panels.controls.close,Close,1,Fermer,1
panels.controls.pin,Pin,1,Épingler,1
panels.controls.unpin,Unpin,1,Désépingler,1
panels.controls.back,Back,1,Retour,1
panels.controls.optionsMenu,More,1,Plus,1
panels.controls.minimize,Minimize,1,Réduire,1
panels.controls.expand,Expand,1,Développer,1
panels.controls.collapse,Collapse,1,Réduire,1
panels.controls.moveRight,Move Right,1,Aller à droite,1
panels.controls.moveLeft,Move Left,1,Aller à gauche,1
panels.controls.items,Use the arrow keys to navigate the items,1,Utilisez les touches fléchées pour naviguer entre les éléments,0
panels.alert.open,{name} panel opened,1,Fenêtre {name} ouverte,1
panels.alert.close,{name} panel closed,1,Fenêtre {name} fermée,1
panels.alert.minimize,{name} panel minimized,1,Fenêtre {name} réduite,1
layer.error,{id} failed to load,1,Échec du chargement de {id},1
layer.longload,{id} is taking longer than expected to load,1,Le chargement de {id} met plus de temps que prévu,1
layer.longdraw,{id} is taking longer than expected to draw,1,{id} prend plus de temps que prévu à extraire,1
layer.mismatch,{name} cannot be displayed in the current projection,1,{id} ne peut pas s'afficher dans la projection actuelle,1
layer.filtersdisabled,Filters have been disabled for {name},1,Les filtres ont été désactivés pour {name},1
layer.filterwarning,You are attempting to use a grid that contains unmodifiable layers. Filtering will be partially disabled.,1,Vous essayez d'utiliser une grille qui contient des couches non modifiables. Le filtrage sera partiellement désactivé.,1
layer.noexportmap,{name} was attempted to be added as a Map Image Layer but Map Export is not enabled for the service,1,La tentative d’ajouter {name} comme couche d’imagerie cartographique a échouée car elle n’a pu être activé pour ce service,1
caption.attributionDefaultText,Powered by ESRI,1,Propulsé par ESRI,0

